import axios, { AxiosInstance } from 'axios';
import { apiUserManagerURL, mockAndDevelopment } from 'src/app.config';

const userManagerClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiUserManagerURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default userManagerClient;
